import { DataSource } from '@n7-frontend/core';
import { IDataWidgetData } from '@n7-frontend/components';
import { Utils } from './utils';
export class ChartDatawDS extends DataSource {

  protected transform(data, option): IDataWidgetData {
    if (!data || !data.companies || !data.companies.length) {
      return;
    }

    const economicalData = data.companies[0].economical_data;
    let increment = 0;
    let lastValue = '';
    let showSubtitle = true;

    const subText = option['key'];
    if (subText) {
      switch (subText.toLowerCase()) {
        case 'ricavi':
          {
            const l =economicalData.revenues.values.length;
            const last = l > 0 ? economicalData.revenues.values[l - 1].value : null;
            const beforelast = l > 1 ? economicalData.revenues.values[l - 2].value : 1;
            increment = Math.round((last - beforelast) * 100 / beforelast);
            if (economicalData.revenues.last_value) {
              lastValue = Utils.bigNumberConverter(economicalData.revenues.last_value) + '€';
            }
          }
          break;
        case 'utile':
          {
            const l =economicalData.profit.values.length;
            const last = l > 0 ? economicalData.profit.values[l - 1].value : null;
            const beforelast = l > 1 ? economicalData.profit.values[l - 2].value : 1;
            increment = Math.round((last - beforelast) * 100 / beforelast);
            if (economicalData.profit.last_value) {
              lastValue = Utils.bigNumberConverter(economicalData.profit.last_value) + '€';
            }
          }
          break;
        case 'ebitda':
          {
            const l =economicalData.ebitda.values.length;
            const last = l > 0 ? economicalData.ebitda.values[l - 1].value : null;
            const beforelast = l > 1 ? economicalData.ebitda.values[l - 2].value : 1;
            increment = Math.round((last - beforelast) * 100 / beforelast);
            if (economicalData.ebitda.last_value) {
              lastValue = Utils.bigNumberConverter(economicalData.ebitda.last_value) + '€';
            }
          }
          break;
      }
    }

    if (!lastValue) { return; }

    if (!isFinite(increment)) { showSubtitle = false; }

    return {
      // icon: 'n7-icon-earth',
      text: lastValue,
      subtitle: showSubtitle ? {
        text: subText,
        icon: increment > 0 ? 'n7-icon-caret-up' : 'n7-icon-caret-down',
        value: increment + '%',
        payload: 'view percent tooltip '
      } : null,
      payload: 'view earth tooltip',
      classes: increment > 0 ? 'is-positive' : 'is-negative'
    };
  }
}
